import { render, staticRenderFns } from "./CustomerInvoicesDashboard.vue?vue&type=template&id=32955ce8&lang=pug&"
import script from "./CustomerInvoicesDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoicesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoicesDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports